module.exports = __webpack_public_path__ + "static/media/home.e285f16c.svg";